<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
      sort-icon-left
    >
      <template
        v-if="listFilters"
        #top-row="data"
      >
        <td
          v-for="(field,key) in data.fields"
          :key="key"
        >
          <list-column-filter
            v-if="field.key !=='action'"
            :name="field.key"
            :label="field.label"
            :filter="listFilters[field.key]"
            :value="filters[field.key]"
            @onFilterChange="( name, value)=> $emit('onFilterChange', name, value)"
          />
          <b-button
            v-else
            block
            variant="success"
            @click="$emit('onFilterButtonClicked')"
          >
            {{ $t("Search") }}
          </b-button>
        </td>
      </template>
      <!-- A custom formatted type column -->
      <template #cell(type)="data">
        <div v-if="data.value !=='text'">
          <b-link
            :id="`tooltip-target-type-${data.item.id}`"
            :href="data.item.file"
            target="_blank"
          >
            {{ data.item.display_type }}
          </b-link>
          <b-tooltip
            :target="`tooltip-target-type-${data.item.id}`"
            variant="info"
            triggers="hover"
          >
            {{ $t('View') }}
          </b-tooltip>
        </div>
        <span v-else>
          {{ data.item.display_type }}
        </span>
      </template>
      <!-- A custom formatted body column -->
      <template #cell(body)="data">
        <span :id="`tooltip-target-body-${data.item.id}`">
          {{ data.value | summaryText(30) }}
        </span>
        <b-tooltip
          v-if="data.value.length > 30"
          :target="`tooltip-target-body-${data.item.id}`"
          variant="info"
          triggers="hover"
        >
          {{ data.value }}
        </b-tooltip>
      </template>
      <!-- A custom formatted to column -->
      <template #cell(to)="data">
        <span
          class="d-block"
          style="direction: ltr"
        >{{ data.value }}</span>
      </template>
      <!-- A custom formatted payment_at column -->
      <template #cell(status)="data">
        <span
          :id="`tooltip-target-${data.item.id}`"
          :class="{ 'text-info' : data.value > 2 , 'text-danger' : data.value < 1}"
        ><font-awesome-icon
          :icon="statusIcon(data.value)"
        /></span>
        <b-tooltip
          :target="`tooltip-target-${data.item.id}`"
          :variant="statusColor(data.value)"
          triggers="hover"
        >
          <span>{{ data.item.display_status }}</span>
          <p v-if="data.value < 1 && data.item.error">
            {{ data.item.error }}
          </p>
        </b-tooltip>

      </template>
      <!-- A custom formatted retry_at column -->
      <template #cell(retry_at)="data">
        <display-date-time
          :id="`tooltip-date-target-${data.item.id}`"
          :value="data.value"
        />
        <b-tooltip
          v-if="data.item.sent_at"
          :target="`tooltip-date-target-${data.item.id}`"
          variant="info"
          triggers="hover"
        >
          <span> {{ $t('Message sent at') }}:<display-date-time :value="data.item.sent_at" /></span>
        </b-tooltip>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no messages to display") }}
      </h6>
    </div>
  </div>
</template>

<script>
import { BTooltip, VBTooltip, BLink } from 'bootstrap-vue'
import { ListTable } from '../../../common/mixins/list'

export default {
  name: 'MessagesList',
  components: {
    BTooltip,
    BLink,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [ListTable],
  methods: {
    statusIcon(status) {
      switch (status) {
        case -12:
          return 'fa-solid fa-ban'
        case -11:
        case -3:
          return 'fa-solid fa-calendar-alt'
        case -2:
          return 'fa-solid fa-spinner'
        case -1:
          return 'fa-solid fa-paper-plane'
        case 1:
          return 'fa-solid fa-check'
        case 2:
        case 3:
        case 4:
        case 5:
          return 'fa-solid fa-check-double'
        default:
          return 'fa-solid fa-xmark'
      }
    },
    statusColor(status) {
      switch (status) {
        case -11:
        case -3:
        case -2:
          return 'warning'
        case -1:
          return 'info'
        case 1:
        case 2:
          return 'secondary'
        case 3:
        case 4:
        case 5:
          return 'info'
        default:
          return 'danger'
      }
    },
  },
}
</script>

<style scoped>

</style>
